export default "__VITE_PUBLIC_ASSET__4023b8b9__"